/**
 * ============================================================================
 * GET WEEK NUMBERS API — accessor for GET /getWeekNumbers.
 * ============================================================================
 *
 * LAYER: accessor. The week universe (-55/+4 around the current week) —
 * the backend owns all week arithmetic including year boundaries.
 */

import { ReportingApiClient } from 'src/accessors/ReportingApiClient';
import { GetWeekNumbersResponse } from 'src/types/weekNumbersApi.types';

class GetWeekNumbersApiClient extends ReportingApiClient {
  public async getWeekNumbers(): Promise<GetWeekNumbersResponse> {
    // Deployed API Gateway exposes GET (no POST method on /getWeekNumbers —
    // POSTing yields API GW's "Missing Authentication Token" route-miss).
    return this.get<GetWeekNumbersResponse>('/getWeekNumbers');
  }
}

/** Singleton (portal convention): one shared instance app-wide. */
export const GetWeekNumbersApi = new GetWeekNumbersApiClient();
